/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ModerationIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/UlEQVR4nN1Vy2oUQRQtUVCJD1DEZZDsRMGtbnoVbczcxwRu3+tEHWY+QkUkjIIS/Q3JHwRxqyTZi67VpeIm0YViEiPVPZ2Z9FQ/stQLvak6p07VObernPtvCtjWkG139OkmYtKr4yFbH8h+7OOSroeAu8UPyLaBtVW2OFFyA9m2QtxGAqkI23eizuUJPMpFINso4zUWwEzkE4Cdz7EicgZJP1dxAgK6WSOyFnW7x9K82hZXYsk2JgUw6XnPa0SWnXOHROQwkK6U4LaArRsMrcV6vcpXzLprMdsQnkTWd8W8sG1zrqrm2skl73mFyB9sJwsee3O+M42sX4bjH33wrkkx3zkLbG9LRUh/tvjWVY8l6lxB1uexyDl3kIrj+CiSvqyw6huzzriDFmJyN7fABwqkg9SW4EnsfRwvnMq5InK8enG2/qjVdJCPE2nH21Ii8mrYVQMg3QHSh40EAiLXgPRr2UnGODve3lIRIL1fWGBpbw7kArJ+qG5je1SfA9lq2UlE5DSwvg7/wSNcsKIoOoJsT+vIUYoLnmQpv04avAept6uFsX6WlS7WXClvJm2Z/JmeDTMZ7I1h0hORE4W2fQJkLwqX3XZIYN/DMTt7e2psrj/+ugHZ40wku5e8LYUN/goI6INcxNtVGZZzbnwDKZ90fZjVbyC7V8f/d+ovF/wYN0dZ63MAAAAASUVORK5CYII=)
 */
export const ModerationIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5.26 12.45c.1.03.18.08.25.14l.52.44 5.26 5.26a1 1 0 0 1 0 1.42l-.58.58a1 1 0 0 1-1.42 0l-1.61-1.61a.25.25 0 0 0-.36 0L6.3 19.7a1 1 0 0 0-.29.7V21a1 1 0 0 1-1 1H3.41a1 1 0 0 1-.7-.3l-.42-.4a1 1 0 0 1-.29-.71V19a1 1 0 0 1 1-1h.59a1 1 0 0 0 .7-.3l1.03-1.02c.1-.1.1-.26 0-.36l-1.61-1.61a1 1 0 0 1 0-1.42l.58-.58a1 1 0 0 1 .97-.26ZM18.01 10.37a1 1 0 0 1-1.4-.11L13.86 7a1 1 0 0 1 0-1.3l2.7-3.18c.28-.34.7-.53 1.14-.53H21a1 1 0 0 1 1 1v3.3c0 .45-.2.86-.53 1.15L18 10.37Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.45 2.53A1.5 1.5 0 0 0 6.3 2H3a1 1 0 0 0-1 1v3.3c0 .45.2.86.53 1.15l11.72 9.92c.11.1.12.26.02.36L13.2 18.8a1 1 0 0 0 0 1.42l.58.58a1 1 0 0 0 1.42 0l1.61-1.61c.1-.1.26-.1.36 0l.53.53a1 1 0 0 1 .29.7V21a1 1 0 0 0 1 1h1.59a1 1 0 0 0 .7-.3l.42-.4a1 1 0 0 0 .29-.71V19a1 1 0 0 0-1-1h-.59a1 1 0 0 1-.7-.3l-.53-.52a.25.25 0 0 1 0-.36l1.61-1.61a1 1 0 0 0 0-1.42l-.58-.58a1 1 0 0 0-1.42 0l-1.06 1.06c-.1.1-.27.1-.36-.02L7.45 2.53Z"
        className={colorClass}
      />
    </svg>
  );
};
